import axios from 'axios';

const state = {
    broadcast_preset: "",
};

const getters = {};

const actions = {
    broadcast_preset_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('broadcast-presets', { params: data })
                .then(response => {
                    commit("PUSH_BROADCAST_PRESET", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    broadcast_preset_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('broadcast-presets', data)
                .then(response => {
                    commit("PUSH_BROADCAST_PRESET", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    broadcast_preset_delete({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('broadcast-presets/' + data.id)
                .then(response => {
                    commit("PUSH_BROADCAST_PRESET", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
}

const mutations = {
    PUSH_BROADCAST_PRESET(state, data) {
        state.broadcast_preset = data
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
